import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Grid, Button } from "@mui/material";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import MarkunreadIcon from '@mui/icons-material/Markunread';
import Form from 'react-bootstrap/Form';
import Alert from '@mui/material/Alert';

import forgotPasswordSchema from "./schema/forgotPassword";
import BtnSpinner from "../../../common/btnSpinner";
import { theme } from "../../../theme";
import InputField from "../../components/InputField";
import { sendForgotPasswordEmail } from "../service";
import useCustomNavigate from "../../../common/hooks/useCustomNavigate";

const ForgotPassword = ({ setShowForgotPassword }) => {
    const { navigateToCustom } = useCustomNavigate();

    const { register, handleSubmit, reset, formState: { errors } } = useForm({
        resolver: yupResolver(forgotPasswordSchema),
    });

    const [loading, setLoading] = useState(false);

    const onSubmit = async({email}) => {
        try{
            setLoading(true);   
            const response = await sendForgotPasswordEmail(email);
            if(response?.status === "Success"){
                navigateToCustom(`forgot/password/${response.customer_id}`);
            }else{
                reset();
                setLoading(false);
            }
        }catch(error){
            console.log(error);
        }
    };

    const handleBackToLogin = () => {
        setShowForgotPassword(false);
    };

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={1}>
                <p className="m-2 text-sm font-medium font-weight-bold">
                    <Alert severity="warning" fullWidth>Please enter the email address used to log into Instafix</Alert>
                </p>
                
                <Grid item xs={12}>
                    <InputField
                        label="Email"
                        placeholder="Email"
                        type="email"
                        icon={<MarkunreadIcon />}
                        error={errors.email}
                        register={register}
                        name="email"
                    />
                </Grid>
            </Grid>

            <div className="text-center">
                <button
                    type="submit"
                    className={`btn bg-gradient-${theme.main} w-100 my-1 mb-0`}
                    disabled={loading}
                >
                    {loading ? <BtnSpinner /> : "Proceed"}
                </button>
            </div>

            <div className="text-center mt-2">
                <Button
                    variant="text"
                    size="small"
                    startIcon={<ArrowBackIosIcon fontSize="small"/>}
                    className={`text-${theme.main} text-gradient font-bold text-xm`}
                    onClick={handleBackToLogin}
                    disabled={loading}
                >
                    Back to Login
                </Button>
            </div>
        </Form>
    );
};

export default ForgotPassword;
